import React, {useCallback, useMemo, useState} from "react";
import {IconButton} from "../../../features/management-v2/import/inputs";
import {usePrettyFileSize} from "../../../lib/files/usePrettyFileSize";
import {useFileSelect} from "../hooks/useFileSelect";
import BasicText from "../../../components/form-v2/basic-text";
import SaveIcon from "@mui/icons-material/Save";
import {useUploadFile} from "../hooks/useUploadFile";
import {platformAPI} from "../../../api/axiosConfig";
import {useNavigateWithClientID} from "../hooks/useNavigateWithClientID";
import {useSiren} from "../SirenContext";
import {useParams} from "react-router-dom";
import {Layout} from "../Layout";
import {ErrorMessage} from "../ErrorMessage";
import LoadingSpinner from "../../../components/ui/LoadingSpinner";
import {useGetNumber} from "../hooks/useGetNumber";
import {HotlineNumber} from "../typedefs";



export function HotlineNumberCreate () {

    const {navigateWithClientID} = useNavigateWithClientID();
    const {clientID} = useSiren()

    const [saveError, setSaveError] = useState<string | null>(null);
    const [saving, setSaving] = useState<boolean>(false);


    const [name, setName] = useState<string>("")
    const [e164, setE164] = useState<string>("")


    const canSave = useMemo(() => {
        if (name.trim() == "") {
            return false
        }

        if (e164.trim() == "") {
            return false
        }

        return true


    }, [e164, name])


    const save = useCallback(async () => {
        setSaving(true);
        setSaveError(null);


        const request = {
            name: name,
            e164: e164,
        }

        try {
            await platformAPI.post("api/hotline-numbers", request)
            navigateWithClientID("/siren/hotlines?subPage=numbers")
        } catch (e) {
            setSaveError("error creating hotline number")
        }

        setSaving(false)


    }, [name, e164])

    return (
        <div className="bg-white shadow-md p-4 flex flex-col gap-4">

            <h1 className={"text-lg font-semibold"}>Create Hotline Number</h1>


            <BasicText label={"Name"} value={name} onChange={setName} required/>
            <BasicText label={"Phone Number"} value={e164} onChange={setE164} required/>
            <div className={"flex flex-col gap-4"}>


                {canSave && (
                    <IconButton onClick={save} text={"Create"} loading={saving} icon={<SaveIcon/>}/>
                )}
                {saveError && (
                    <p className={"text-center text-red"}>{saveError}</p>
                )}


            </div>
        </div>
    )
}
